import { FC, PropsWithChildren, ReactNode } from 'react'

import {
  propsWithClassNames,
  toClassNames
} from '@trustycars/genie-ui/functions'
import { TagsNoRef } from '@trustycars/genie-ui/types'

import { hideWhenEmpty } from '$styles/atoms.css'

import {
  container,
  header,
  nav as navStyle,
  info,
  description as descriptionStyle,
  title as titleStyle
} from './styles.css'

type ElementProps = {
  containerProps?: TagsNoRef<'article'>
  mainProps?: TagsNoRef<'main'>
  navProps?: TagsNoRef<'nav'>
}

type ClassNameProps = Partial<
  Record<'headerClassName' | 'mainClassName', string>
>

type DataProps = {
  title?: ReactNode
  description?: ReactNode
  nav?: ReactNode
}

export type PageContentsProps = ElementProps & DataProps & ClassNameProps

export const PageContents: FC<PropsWithChildren<PageContentsProps>> = ({
  children,
  containerProps,
  mainProps,
  navProps,
  nav,
  description,
  title,
  headerClassName,
  mainClassName
}) => (
  <article {...propsWithClassNames(containerProps, hideWhenEmpty, container)}>
    {(description || title || nav) && (
      <header className={toClassNames(header, headerClassName)}>
        {(description || title) && (
          <div className={info}>
            {title && <h2 className={titleStyle}>{title}</h2>}

            {description && (
              <div role="definition" className={descriptionStyle}>
                {description}
              </div>
            )}
          </div>
        )}

        {nav && (
          <nav children={nav} {...propsWithClassNames(navProps, navStyle)} />
        )}
      </header>
    )}

    {children && (
      <main
        children={children}
        {...propsWithClassNames(mainProps, hideWhenEmpty, mainClassName)}
      />
    )}
  </article>
)

export default PageContents
